import * as Sentry from "@sentry/browser"
import { fullStoryIntegration } from "@sentry/fullstory"
import { FullStory } from "@fullstory/browser"
import environment from "../utils/env"

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: environment,
  release: `core-js@${import.meta.env.VITE_APP_VERSION}`,
  integrations: [
    fullStoryIntegration("bmx", { client: FullStory }),
  ],
})

Sentry.setTag("app_version", import.meta.env.VITE_APP_VERSION)
Sentry.setTag("region", import.meta.env.VITE_APP_REGION)
